<button type="button" #addAssetButton command="show-modal" commandfor="addAssetDialog"
    class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-2 transition-all ease-in-out duration-300">

    Upload Assets

    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
        <path d="M12 13v8" />
        <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
        <path d="m8 17 4-4 4 4" />
    </svg>
</button>


<el-dialog>
    <dialog #addAssetDialog id="addAssetDialog" aria-labelledby="addAssetDialog-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">

                        <!-- header -->
                        <div class="shrink-0 px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center justify-between">
                                <div class="min-w-0 flex-1 px-2 text-start">
                                    <h2 id="addAssetDialog-title" class="text-md font-semibold text-primary m-0">
                                        Add Assets
                                    </h2>
                                    <p class="text-sm text-secondary m-0">
                                        Upload missing images or a video for this content.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="btn-fab-secondary text-secondary" aria-label="Close add assets drawer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col w-full overflow-y-auto drawer-body-primary p-4 space-y-4">

                            <fieldset class="m-0 p-0 border-0 mb-6">
                                <legend class="block text-sm font-medium text-primary mb-2">Asset type</legend>
                                <div class="grid grid-cols-2 gap-2" role="group" aria-label="Choose asset type">
                                    <button type="button" (click)="setAssetType('images')"
                                        [disabled]="saving()"
                                        class="rounded-lg border px-3 py-2 text-sm font-medium transition-colors"
                                        [class]="assetType() === 'images'
                                            ? 'border-primary bg-primary/10 text-primary'
                                            : 'border-zinc-300 dark:border-zinc-600 text-secondary'">
                                        Images
                                    </button>
                                    <button type="button" (click)="setAssetType('video')"
                                        [disabled]="saving()"
                                        class="rounded-lg border px-3 py-2 text-sm font-medium transition-colors"
                                        [class]="assetType() === 'video'
                                            ? 'border-primary bg-primary/10 text-primary'
                                            : 'border-zinc-300 dark:border-zinc-600 text-secondary'">
                                        Video
                                    </button>
                                </div>
                            </fieldset>

                            @if (assetType() === 'images') {
                            <div class="space-y-3">
                                <p class="text-sm text-secondary m-0">Select one or more images for a carousel.</p>

                                @if (selectedImageFiles().length === 0) {
                                <div class="flex justify-center rounded-lg border border-dashed p-6 transition-colors"
                                    [class]="isDragging()
                                        ? 'border-primary bg-primary/10'
                                        : 'border-zinc-300 dark:border-zinc-600'"
                                    role="region" aria-label="Image upload drop zone"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event)">
                                    <div class="text-center">
                                        <label for="monitoring-image-upload"
                                            class="cursor-pointer text-sm font-semibold text-accent">
                                            Upload images
                                            <input id="monitoring-image-upload" type="file" accept="image/*" multiple
                                                class="sr-only" (change)="onFileInputChange($event)"
                                                [disabled]="saving()" />
                                        </label>
                                        <p class="mt-1 text-xs text-secondary m-0">or drag and drop · PNG, JPG, WebP</p>
                                    </div>
                                </div>
                                } @else {
                                <ul class="grid grid-cols-2 gap-2 list-none m-0 p-0">
                                    @for (preview of imagePreviewUrls(); track preview; let i = $index) {
                                    <li class="relative aspect-square overflow-hidden rounded-lg border border-zinc-200 dark:border-zinc-700">
                                        <img [src]="preview" [alt]="'Selected image ' + (i + 1)"
                                            class="h-full w-full object-cover" />
                                        <button type="button" (click)="removeImageAt(i)" [disabled]="saving()"
                                            class="absolute top-1 right-1 rounded bg-black/60 px-2 py-0.5 text-xs text-white"
                                            [attr.aria-label]="'Remove image ' + (i + 1)">
                                            Remove
                                        </button>
                                    </li>
                                    }
                                </ul>
                                <label for="monitoring-image-upload-more"
                                    class="inline-flex cursor-pointer text-sm font-semibold text-accent">
                                    Add more
                                    <input id="monitoring-image-upload-more" type="file" accept="image/*" multiple
                                        class="sr-only" (change)="onFileInputChange($event)" [disabled]="saving()" />
                                </label>
                                }
                            </div>
                            } @else {
                            <div class="space-y-3">
                                <p class="text-sm text-secondary m-0">Select a single video file.</p>

                                @if (!selectedVideoFile()) {
                                <div class="flex justify-center rounded-lg border border-dashed p-6 transition-colors"
                                    [class]="isDragging()
                                        ? 'border-primary bg-primary/10'
                                        : 'border-zinc-300 dark:border-zinc-600'"
                                    role="region" aria-label="Video upload drop zone"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event)">
                                    <div class="text-center">
                                        <label for="monitoring-video-upload"
                                            class="cursor-pointer text-sm font-semibold text-accent">
                                            Upload a video
                                            <input id="monitoring-video-upload" type="file" accept="video/*"
                                                class="sr-only" (change)="onFileInputChange($event)"
                                                [disabled]="saving()" />
                                        </label>
                                        <p class="mt-1 text-xs text-secondary m-0">or drag and drop · MP4, MOV, WebM</p>
                                    </div>
                                </div>
                                } @else {
                                <div class="relative overflow-hidden rounded-lg border border-zinc-200 dark:border-zinc-700 bg-zinc-950 aspect-square">
                                    @if (videoPreviewUrl(); as preview) {
                                    <video [src]="preview" controls class="h-full w-full object-contain"></video>
                                    }
                                    <button type="button" (click)="clearVideo()" [disabled]="saving()"
                                        class="absolute top-2 right-2 rounded bg-black/60 px-2 py-1 text-xs text-white"
                                        aria-label="Remove selected video">
                                        Change
                                    </button>
                                </div>
                                <p class="text-xs text-secondary m-0">{{ selectedVideoFile()?.name }}</p>
                                }
                            </div>
                            }

                            @if (saving()) {
                            <div class="w-full space-y-1" role="status" aria-live="polite">
                                <p class="text-sm text-secondary m-0">Uploading… {{ s3Uploader.uploadPercentage() }}%</p>
                                <div class="h-2 w-full overflow-hidden rounded-full bg-zinc-200 dark:bg-zinc-700"
                                    role="progressbar"
                                    [attr.aria-valuenow]="s3Uploader.uploadPercentage()"
                                    aria-valuemin="0" aria-valuemax="100">
                                    <div class="h-full bg-primary transition-[width] duration-300"
                                        [style.width.%]="s3Uploader.uploadPercentage()"></div>
                                </div>
                            </div>
                            }
                        </div>
                        <!-- main content - END -->

                        <!-- Footer -->
                        <div
                            class="shrink-0 px-4 py-4 drawer-header-primary flex flex-row items-center justify-between gap-x-4">
                            <button (click)="closeDrawer()" type="button" [disabled]="saving()"
                                class="secondary-button inline-flex flex-row items-center gap-x-2">
                                Cancel
                            </button>
                            <button [disabled]="!canSave()" (click)="saveAssets()" type="button"
                                class="primary-button inline-flex items-center gap-x-2">
                                @if (saving()) {
                                Saving…
                                } @else {
                                Save Assets
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
                                    <path d="M20 6 9 17l-5-5" />
                                </svg>
                                }
                            </button>
                        </div>
                        <!-- Footer - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>
